import { render, staticRenderFns } from "./MobileFoot.vue?vue&type=template&id=9c5b104c"
import script from "./MobileFoot.vue?vue&type=script&lang=js"
export * from "./MobileFoot.vue?vue&type=script&lang=js"
import style0 from "./MobileFoot.vue?vue&type=style&index=0&id=9c5b104c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports